/**
 * 메뉴 API 클라이언트
 */

import apiClient from './client';

export interface MenuItem {
  menuIdx: number;
  menuCd: string;
  icon: string;
  menuUrl: string;
  depth: string;
  parentIdx: number;
  section: string;
  sortOrder: number;
  useYn: string;
  menuYn: string;
  popupYn: string;
  menuNm: string;
}

export interface MenuLangItem {
  menuCd: string;
  langCd: string;
  menuNm: string;
  menuDesc?: string;
}

export interface MenuAdminData {
  menus: MenuItem[];
  langKo: MenuLangItem[];
  langEn: MenuLangItem[];
  /** 역할별 접근 가능 menuIdx 맵 { productAdmin: [...], tenantAdmin: [...], ... } */
  authByRole: Record<string, number[]>;
  authAdmin: number[];
  authUser: number[];
}

export const menuApi = {
  /** 현재 사용자 role + lang 기준 메뉴 목록 */
  async getMenus(lang = 'ko'): Promise<MenuItem[]> {
    const res = await apiClient.get<{ success: boolean; data: MenuItem[] }>(
      `/api/menus?lang=${lang}`
    );
    return res.data.data;
  },

  /** 관리자: 전체 메뉴 데이터 조회 */
  async getAdminAll(): Promise<MenuAdminData> {
    const res = await apiClient.get<{ success: boolean; data: MenuAdminData }>(
      '/api/menus/admin/all'
    );
    return res.data.data;
  },

  /** 관리자: 메뉴 저장 (upsert) */
  async saveMenu(menu: Partial<MenuItem>, langKo?: Partial<MenuLangItem>, langEn?: Partial<MenuLangItem>): Promise<void> {
    await apiClient.post('/api/menus/admin', { menu, langKo, langEn });
  },

  /** 관리자: 메뉴 삭제 */
  async deleteMenu(menuIdx: number, menuCd: string): Promise<void> {
    await apiClient.delete(`/api/menus/admin/${menuIdx}`, { data: { menuCd } });
  },

  /** 관리자: role별 메뉴 권한 저장 */
  async saveMenuAuth(role: string, menuIdxList: number[]): Promise<void> {
    await apiClient.post('/api/menus/admin/auth', { role, menuIdxList });
  },
};

export default menuApi;

